import { Chip, ChipProps } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function HideableChip(
  params: ChipProps & {
    value: string;
    onSwitchVisibility: (value: string) => void;
    visible: boolean;
  }
) {
  const onIconClick = () => {
    params.onSwitchVisibility(params.value);
  };

  return (
    <Chip
      {...params}
      key={`${params.label}-selection-chip`}
      onDelete={onIconClick}
      deleteIcon={
        params.visible ? (
          <VisibilityIcon data-testid="VisibilityOnIcon" />
        ) : (
          <VisibilityOff data-testid="VisibilityOffIcon" />
        )
      }
      sx={
        params.visible
          ? {}
          : { textDecoration: "line-through", color: "rgba(0, 0, 0, 0.38)" }
      }
    />
  );
}
